import { combineReducers } from '@reduxjs/toolkit'

import authReducer from '@/store/slices/authSlice'
import themeReducer from '@/store/slices/themeSlice'

const rootReducer = combineReducers({
  auth: authReducer,
  theme: themeReducer,
})

export default rootReducer
